import { render, staticRenderFns } from "./SubmitForm17.vue?vue&type=template&id=5b77516c&scoped=true"
import script from "./SubmitForm17.vue?vue&type=script&lang=ts"
export * from "./SubmitForm17.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b77516c",
  null
  
)

export default component.exports